import React from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';

import {
  getCurrentMobileLayout,
  getActiveExpert,
  getIsBigTabletAndDesktop,
  getIsKeyboardOpen,
  getIsMobile,
  getIsUserAuthenticated
} from '../../store/selectors';

import s from './index.module.css';

import LayoutRight from './LayoutRight/LayoutRight';
import LayoutLeft from './LayoutLeft/LayoutLeft';
import LayoutNotification from "./LayoutNotification/LayoutNotification";
import Scroll from '../Scroll';

import { SAVED_LAYOUT_VALUE_KEY } from '../../constants/storageKeys';

const Layout = ({ children, isWidgetPath }) => {
  const isAuthenticated = useSelector(getIsUserAuthenticated);
  const isBigTabletAndDesktop = useSelector(getIsBigTabletAndDesktop);
  const isMobile = useSelector(getIsMobile);
  const expert = useSelector(getActiveExpert);
  const mobileLayout = useSelector(getCurrentMobileLayout);
  const isKeyboardOpen = useSelector(getIsKeyboardOpen);
  const storageLayoutValue = sessionStorage.getItem(SAVED_LAYOUT_VALUE_KEY);
  const currentMobileLayout = storageLayoutValue || mobileLayout;

  // return current type with selector
  const isMobileChatActive = currentMobileLayout === 'chat';
  const isDialogListLayoutActive = currentMobileLayout === 'dialogs';
  const isOrderLayoutActive = currentMobileLayout === 'orders';
  const isNotificationLayoutActive = currentMobileLayout === 'notification';

  const mobileEmexLayout = (
    <div className={cx(s.layoutEmex, {
      // [s.openKeyboardLayout]: isKeyboardOpen,
      [s.mobileEmexLayout]: isMobile,
      [s.shiftedChatLayout]: expert && isMobileChatActive
    })}>
      <LayoutLeft className={cx(s.mainDialogWindow, {
        [s.mobileDialogList]: isMobile && !isDialogListLayoutActive,
        [s.mobileDialogListActive]: isDialogListLayoutActive
      })} />

      {/* {isMobileChatActive && */}
        <div className={cx(s.chatWindow,
          {
            [s.mobileChatWindow]: isMobile,
            [s.mobileChatActive]: isMobileChatActive,
          })}>
          {children}
        </div>
      {/* } */}

      <div className={cx({
        [s.mobileOrdersList]: isMobile && !isOrderLayoutActive,
        [s.mobileOrdersListActive]: isOrderLayoutActive,
        [s.mobileOrdersWithMargin]: !isAuthenticated
      })}>
        <LayoutRight className={s.mainWindowRight} />
      </div>

      <div className={cx({
        [s.mobileOrdersList]: isMobile && !isNotificationLayoutActive,
        [s.mobileOrdersListActive]: isNotificationLayoutActive,
        [s.mobileOrdersWithMargin]: !isAuthenticated
      })}>
        <LayoutNotification className={s.mainWindowRight} />
      </div>
    </div>

  );

  const tabletAndDesktopLayout = (
    <div className={cx(s.layoutEmex, {
      [s.widgetLayout]: isWidgetPath,
      // [s.openKeyboardLayout]: isKeyboardOpen
    })}>
      <LayoutLeft className={cx(s.mainWindowLeft, s.rightSideScroll)} />

      <div className={s.chatWindow}>{children}</div>

      <Scroll className={s.rightSideScroll}>
        <LayoutRight className={s.mainWindowRight} />
        <LayoutNotification className={s.mainWindowRight} />
      </Scroll>
    </div>
  );

  return (
    <>
      {isBigTabletAndDesktop && tabletAndDesktopLayout}
      {isMobile && mobileEmexLayout}
    </>
  );
};

export default Layout;
